//#region libraries
import React, { useEffect, useState } from "react"
//moment
import moment from 'moment';
//redux
import { useSelector, useDispatch } from "react-redux";
import { selectPaxQuestions, selectReviewBooking, selectReviewTask, postSurveyAnswers, resetAddSurveyAnswersStatus, setSelectedPassenger, selectedPassenger } from "_redux/slices/analytics/review-control-panel";
import { selectAirportLogo, selectAirportLogoStatus } from "_redux/slices/analytics/reviews";
//styles
import { Colors } from "_styles";

//custom component
import SurveyRunner from "./survey-runner";

import PRMLogo from "../../../assets/images/PRM-Logo-PNG/logo.png"
import SGSLogo from "../../../assets/images/logo/SGS-logo.png";
import VISIONSGS from "../../../assets/images/logo/VISIONSGS-logo.png";
import { extractNameFromBookingId } from "_utils/functions";
import { translate } from "./surveys-utils";

//#endregion

// Passenger survey adapter: keeps the redux/booking wiring and hands the shared
// SurveyRunner a flattened `questions` array plus an onSubmit that persists answers.
const SurveyQuestions = ({ iata, language, taskId, multiplePaxs }) => {
    //#region redux
    const dispatch = useDispatch();

    const task = useSelector(selectReviewTask);
    const booking = useSelector(selectReviewBooking);
    const checkedPassenger = useSelector(selectedPassenger)
    const paxSurveyQustions = useSelector(selectPaxQuestions);
    const airportLogo = useSelector(selectAirportLogo);
    const airportLogoStatus = useSelector(selectAirportLogoStatus);
    //#endregion

    const [iataLogo, setIataLogo] = useState("")

    useEffect(() => {
        if (airportLogoStatus === "succeeded") setIataLogo(airportLogo)
        if (airportLogoStatus === "failed") setIataLogo(PRMLogo)
    }, [airportLogoStatus])

    //#region build + persist answers
    const buildSurveyInfoObject = () => {
        if (taskId === "email-survey") return {};
        const customSurveyAnswerId = `${iata}--${paxSurveyQustions._id}`;
        const surveysArray = [
            ...task.surveyInfo?.surveys || [],
            {
                surveyAnswersId: customSurveyAnswerId,
                bookingId: checkedPassenger ?? booking.id
            }
        ]
        const surveyStatus = (!multiplePaxs) ? "completed" : task.passengers.length === surveysArray.length ? "completed" : "not_completed"
        return {
            // taskId (URL) is the authoritative task id; it equals task._id when the
            // task doc is found, and stays correct even if the fetch missed.
            id: taskId,
            surveyInfo: {
                status: surveyStatus,
                suveyId: customSurveyAnswerId,
                type: multiplePaxs ? "MULTIPLE" : "ONE",
                surveys: surveysArray
            }
        }
    }

    const getBookingDetails = () => {
        if (multiplePaxs) {
            return {
                bookingId: checkedPassenger,
                passengerName: extractNameFromBookingId(checkedPassenger),
                origin: task.flightInformation.departureAirport,
                destination: task.flightInformation.arrivalAirport,
                flightNumber: task.flightNumber,
                createdAt: new Date()
            }
        }
        return {
            bookingId: booking.id,
            passengerName: booking.name,
            origin: booking.flightConfirmationDetails.origin,
            destination: booking.flightConfirmationDetails.destination,
            flightNumber: booking.flightConfirmationDetails.carrierCode + booking.flightConfirmationDetails.flightNumber,
            createdAt: booking.createdAt
        }
    }

    const handleSubmit = async (answers) => {
        const surveyAnswer = {
            iata,
            surveyTitle: paxSurveyQustions.groupTitle,
            surveyId: paxSurveyQustions._id,
            createdAt: moment(new Date()).format().split("T")[0],
            taskDetails: {
                taskId: taskId || "email-survey",
                // Fallback only: single-pax QR surveys don't fetch the task, so the server
                // stamps the real employeeId from the task on save (crud-survey-answers.js).
                employeeId: task?.employeeId || "email",
            },
            bookingDetails: getBookingDetails(),
            answers,
            language,
            completed: true,
            surveyInfo: buildSurveyInfoObject()
        }
        await dispatch(postSurveyAnswers(surveyAnswer)).unwrap();
        dispatch(resetAddSurveyAnswersStatus());
        dispatch(setSelectedPassenger(null));
    }
    //#endregion

    //#region completion screen
    const renderCompleted = () => (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
            <div style={{ marginTop: "10px", textAlign: "center" }}>
                <p style={{ fontSize: 22, color: Colors.PRM_LIGHT_BLUE, opacity: 0.8, textAlign: "center" }}>
                    {translate('finalBtn', language)}
                </p>
                <p style={{ fontSize: 18, direction: language === "ar" ? "rtl" : "ltr" }}>{translate('finalPhrase', language)}</p>
            </div>

            {iata === "JED" ? (
                <div>
                    <img src={SGSLogo} alt="SGS LOGO" style={{ maxWidth: "50%", minWidth: "50%" }} />
                    <img src={VISIONSGS} alt="Vision SGS LOGO" style={{ maxWidth: "50%", minWidth: "50%", height: "60%" }} />
                </div>
            ) : (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexGrow: 1, justifyContent: "center" }} >
                    <img src={iataLogo} alt="Airport logo" style={{ width: "90%", maxWidth: "300px", marginBottom: "10px", maxHeight: "200px", objectFit: "contain" }} />
                    <img src={PRMLogo} alt="PRM LOGO" style={{ width: "90%", maxWidth: "300px", marginBottom: "10px", maxHeight: "200px", objectFit: "contain" }} />
                </div>
            )}

            <h6 style={{ textAlign: "center", fontSize: "14px", width: "100%" }} >
                Powered by{" "} <strong style={{ color: Colors.PRM_LIGHT_BLUE }}>PRM ASSIST</strong>
            </h6>
        </div>
    );
    //#endregion

    return (
        <SurveyRunner
            questions={paxSurveyQustions?.questions || []}
            language={language}
            onSubmit={handleSubmit}
            renderCompleted={renderCompleted}
        />
    )
}

export default SurveyQuestions
